import { Typography } from "src/components/Typography";
import { Css, Palette } from "src/Css";
import { shortMonthYearFormat } from "src/utils";

interface ProgressBarProps {
  title: string;
  completed: number;
  total: number;
  start?: Date;
  end?: Date;
}

export function ProgressBar({ completed, total, start, end, title }: ProgressBarProps) {
  const allTasksComplete = total === completed;

  const unitArray = Array.from(Array(total).keys()).map((i) => {
    const isComplete = i < completed;
    return <UnitDiv isComplete={isComplete} isFirst={i === 0} isLast={i === total - 1} key={i} />;
  });

  return (
    <>
      <div css={Css.mb2.df.$}>
        <div css={Css.mra.header16.fw4.$}>{title}</div>
        <div css={Css.f14.gray400.$}>
          {completed} of {total} Complete
        </div>
      </div>
      <div css={Css.df.$}>{unitArray}</div>
      {start && end && (
        <>
          <div css={Css.mt1.df.jcsb.$}>
            <Typography size="f12" lineHeight={18} color={Palette.Gray600}>
              {shortMonthYearFormat(start)}
            </Typography>
            <Typography size="f12" lineHeight={18} color={Palette.Gray600}>
              {shortMonthYearFormat(end)}
            </Typography>
          </div>
          <div css={Css.df.jcsb.$}>
            <Typography size="f12" color={Palette.Gray600}>
              Start
            </Typography>
            <Typography size="f12" color={Palette.Gray600}>
              {allTasksComplete ? "Completed" : "End"}
            </Typography>
          </div>
        </>
      )}
    </>
  );
}

interface UnitDivProps {
  isComplete: boolean;
  isFirst: boolean;
  isLast: boolean;
}

function UnitDiv(props: UnitDivProps) {
  const { isComplete, isFirst, isLast } = props;
  const borderRadius = isFirst && isLast ? "8px" : isFirst ? "8px 0 0 8px" : isLast ? "0 8px 8px 0" : "0";
  return <div css={Css.bgGray200.mxPx(1).h2.w100.borderRadius(borderRadius).if(isComplete).bgGreen200.$} />;
}
